<template>
	<div class="syBox clearfix">
		<div class="list_manage_wrap fl_left">
			<div class="list_manage">
				<div class="top_tit">
					所有类目
					<span class="adds" @click='add()'>+</span>
					<div class="add_list" v-if="show">
						<div class="title">类目名称</div>
						<input type="text" class="ipt" placeholder="名称" v-model="course"></br>
						<button class="ok_q btn" @click="ok_q">确定</button> <button class="btn cancle" @click="cancle">取消</button>
					</div>
				</div>
			</div>
			<div class="le_k">
				<div class="dancelist" v-if="dancelist" v-for="(item,index) in dancelist" :key="index" :class="{bor_left:key === item.id }" @click="change_tep(index)">{{item.name}}</div>
			</div>
			<div class="total_cl">
				<router-link tag="div" to="/manager/addCategory/centersCon/index/CateManage" class="toatls">类目管理</router-link>
			</div>
		</div>
		<div class="fl_left">
			<div class="default_con" v-if="pack">
				<div><img src="static/imgs/login_logo.png" alt=""></div>
				<div>让艺术开启孩子幸福人生</div>
			</div>
			<div class="list_currb" v-else>
				<router-view></router-view>
				<!-- <neweditor :formDat="course"></neweditor> -->
			</div>
			
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				course:'',
				pack:true,
				list:[],
				dancelist:[],
				show:false,
				key: '',
			}
		},
		methods:{
			add(){
				this.show = true
			},
			ok_q(){
				const _this=this;
				if(this.course==""){
					this.$message({
						message:'内容不能为空',
		    			showClose:true,
		    			type:'waring'
					})
				}else{
					if(this.dancelist==''){
						this.dancelist=[]
						this.dancelist.push(this.course);
					}
					$('.adds').hide()
					this.show = false
					localStorage.setItem('reTurn',this.indexs=false)
					_this.$axios.post('addcourse',{
						course_name:this.course
					}).then((res)=>{
						if(res.data.code==200){
							_this.dancelist.push({name:this.course});
							var arr=[this.dancelist.length-1,this.dancelist[this.dancelist.length-1].id]
           					sessionStorage.setItem('courseNum',JSON.stringify(arr))
           					_this.key = this.dancelist[this.dancelist.length-1].id
           					this.pack=false;
							localStorage.setItem('courseName',this.course)
							_this.course=this.$md5(this.course)
							this.$router.push({
			               		path:'/manager/addCategory/centersCon/newPeriods',
			               		name:'newPeriods',
			               		query:{
			               			name:this.course
			               		}
				            })
							
							this.indexs=false
						}else if(res.data.code==99){
							alert("该舞种已存在")
						}
						
					}).catch( error =>{
						console.log(error)
					})
					
				}
			},
			cancle(){
				this.course = ''
				this.show = false
			},
			change_tep(i){
				this.$set(this.dancelist,i,this.dancelist[i]);
				this.key = this.dancelist[i].id
               	var arr=[i,this.dancelist[i].id]
               	sessionStorage.setItem('courseNum',JSON.stringify(arr))
               	this.$router.push({
               		path:'/addCategory/singleLesson',
               		name:'singleLesson'
               })
			}
		 },
		created(){
		 	const _this=this;
		 	_this.$axios.post('getdancelist',{}).then((res)=>{
		 		if(res.data.code == 200){
		 			_this.dancelist=res.data.data;
		 		}
				else{
					_this.$message.error(res.data.message)
				}
			}).catch((err)=>{
				console.log(err)
			})
		},
		destroyed(){
		 	this.indexs=false;
		 	this.xs=true;
		}
	};
</script>
<style scoped>
	.syBox{
		width: 1152px;
		margin: 20px auto 0;
	}
	.list_manage_wrap{
		width:210px;
		border-radius: 4px;
		background: #fff;
		margin-right: 20px;
	}
	.top_tit{
		font-size: 14px;
		height: 52px;
		line-height: 52px;
		border-bottom: 1px solid #f5f5f5;
		text-indent: 29px;
		position: relative;
	}
	.add_list{
		width: 292px;
		height: 172px;
		background: #fff;
		box-shadow: -1px -1px 10px rgba(0,0,0,0.09),1px 1px 10px rgba(0,0,0,0.09);
		position: absolute;
		bottom: -176px;
		right:-235px;
		padding: 0 30px;
		box-sizing: border-box;
		z-index: 99;
	}
	.add_list:after{
		position: absolute;
		top: -20px;
		left: 30px;
		content: "";
		border-color: transparent transparent #fff transparent;
		border-style: solid;
		border-width: 10px;
	}
	.add_list:before{
		position: absolute;
		top: -24px;
		left: 28px;
		content: "";
		border-color: transparent transparent rgba(0,0,0,0.09) transparent;
		border-style: solid;
		border-width: 12px;
	}
	.title{
		line-height: 44px;
		text-align: center;
	}
	.ipt{
		width: 230px;
		height: 36px;
		line-height: 36px;
		border:1px solid #ddd;
		border-radius: 4px;
		padding-left: 13px;
		box-sizing: border-box;
	}
	.ok_q{
		background: #595db5;
		color: #fff;
		font-size: 14px;
	}
	.btn{
		width: 106px;
		height: 36px;
		text-align: center;
		line-height: 36px;
		border:none;
		outline: none;
		border-radius: 4px;
		cursor: pointer;
	}
	.cancle{
		background: #fff;
		border:1px solid #ddd;
		margin-left: 13px;
	}
	.adds{
		margin-left: 92px;
		font-size: 20px;
		color: rgba(1,171,108,1);
		cursor: pointer;
		font-weight: bold;
	}
	/*.active{
		border-left: 3px solid #3d4399;
		text-indent: 27px;
	}*/
	.dancelist{
		text-indent: 30px;
		height: 32px;
		font-size: 14px;
		color: #333;
		line-height: 32px;
		margin-top: 10px;
		border-left: 3px solid transparent;
		cursor: pointer;
	}
	.dancelist:hover{
		background: rgba(1,171,108,1);
		color: #fff;
	}
	.total_cl{
		width: 100%;
		box-sizing: border-box;
		padding: 20px;
	}
	.toatls{
		cursor: pointer;
		border-radius: 4px;
		width: 170px;
		height: 34px;
		border:1px dashed #bfbfbf;
		line-height: 34px;
		text-align: center;
		color: #666;
		font-size: 12px;
	}
	.list_currb{
		width:922px;
	}
	.bor_left{
		border-left: 3px solid rgba(1,171,108,1);
	}
	.default_con{
		width: 922px;
		height: 620px;
		box-sizing: border-box;
		background: #fff;
		border-radius: 4px;display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		font-size: 18px;
		color: #b3b3b3;
	}
	.default_con img{
		width: 106px;
		height:106px;
		margin-bottom: 30px;
	}
	
	
</style>


// WEBPACK FOOTER //
// src/components/centersCon.vue